import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
// import http from "../services/httpService";
import http from "../services/reportsPath";
import FormControl from "@material-ui/core/FormControl";
import Box from "@mui/material/Box";
import { ReactComponent as FilterLogo } from "../images/filter.svg";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import {
  MenuItem,
  Select,
  TableSortLabel,
  TextField,
  ListItemIcon,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
import { Button, Grid, SvgIcon, TableBody } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import {
  viewSalesMisReportsPath,
  searchFilter,
  getDate,
  handleSort,
  viewmissalesreportsdetailsPath,
  getDateTime,
  ViewCDTyetToSubscribePath,
  ViewCdtParticularPath,
} from "../utils/varialbles";
import InputLabel from "@material-ui/core/InputLabel";

import SearchBar from "material-ui-search-bar";
import TablePagination from "@material-ui/core/TablePagination";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Table from "@material-ui/core/Table";
import toast from "react-hot-toast";
import Typography from "@material-ui/core/Typography";

import FilterListSharpIcon from "@material-ui/icons/FilterListSharp";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 220,
    },
  },
};
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  menuPaper: {
    maxHeight: 100,
  },
}));

// const useStyles = makeStyles({
//     root: {
//         width: '100%',
//         backgroundColor: "#F5F7FA",
//         padding: "7px"
//     },
//     tile: {
//         height: "80px",
//         backgroundColor: "#FFF",
//         textAlign: "center",
//         width: "80%",
//         cursor: "pointer",
//         color: "#393939",
//         padding: "5%",
//         border: "#67729429",
//         '&:hover': {
//             backgroundColor: "#3f51b5",
//             color: "#F5F7FA"
//         }
//     },
//     analyticwindow: {
//         backgroundColor: "#F5F7FA",
//         color: "#393939",
//         width: "300px"
//     },
//     button: {
//         marginRight: "5px",
//         borderRadius: "10px"
//     }

// });
let uniqueApiNames = {};
let firstEmployeeList = "";
function MisSalesReportParent() {
  const classes = useStyles();

  const location = useLocation();

  const history = useHistory();
  const [selectedEmployeeName, setSelectedEmplloyeeName] = useState("");
  const [rows, setRows] = useState([]);
  const [searched, setSearched] = useState("");
  const [page, setPage] = useState(0);
  const [orignalRows, setOriginalRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [columns, setColumns] = useState([]);
  const [employeesList, setEmployeesList] = useState([]);
  const [totalRowCount, setTotalRowCount] = React.useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState({
    property: "",
    order: "asc",
  });
  const [Filters, setFilters] = useState(false);

  const requestSearch = (searchedVal) => {
    // (searchedVal);
    let rowsTemp = [...orignalRows];
    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };
  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Filter starts

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isFilterData, setIsFilterData] = useState([]);
  const [appliedFilter, setAppliedFilter] = useState([]);
  const [isFilterString, setIsFilterString] = useState(
    localStorage.getItem("selectedinvestorfiltersdata") || ""
  );
  const [isRange, setIsRange] = React.useState(false);
  const [filterTrue, setFilterTrue] = useState(false);
  const [counter, setCounter] = useState(0);
  const [isSelectedData, setIsSelectedDatas] = useState([
    {
      id: 1,
      options: [],
      name: "Country",
    },
    {
      id: 2,
      options: [],
      name: "Demat Accounts Linked",
    },
    {
      id: 3,
      data: { equalTo: "" },
      name: "Signup Date",
    },
    {
      id: 4,
      data: { equalTo: "" },
      name: "Customer Income",
    },

    {
      id: 5,
      data: { equalTo: "" },
      name: "Total Invested Value",
    },
    {
      id: 6,
      data: { equalTo: "" },
      name: "Advise Returns CAGR%",
    },
    {
      id: 7,
      data: { equalTo: "" },
      name: "Payment Date",
    },
    {
      id: 8,
      data: { equalTo: "" },
      name: "Customer Age",
    },
    {
      id: 9,
      data: { equalTo: "" },
      name: "No. Of Advices Given'",
    },
  ]);

  const openFilter = (e) => {
    // setIsMenuOpen(true);
    setIsFilterOpen(true);

    // let currentTarget = e.currentTarget;
    // setAnchorEl(currentTarget);
    // setAnchorEl(true);
  };
  const closeFilter = () => {
    setIsFilterOpen(false);
  };

  const handleSelectChange = (v, id, meta) => {
    // ('am ', v, id);
    if (v === "range") {
      setIsRange(true);
    } else {
      // setIsRange(false);
    }
    setIsSelectedDatas((fstate) => {
      const newState = isFilterData.map((x) => {
        if (x.id === id) {
          if (x.type === "select") {
            return {
              name: x.name,
              id: x.id,
              options: v,
            };
          } else if (x.type === "radio") {
            return {
              name: x.name,
              id: x.id,
              options: [v],
            };
          } else if (x.type === "date" || x.type === "number") {
            if (meta === "option") {
              const fstateObject = fstate.find((filter) => filter.id === x.id);
              let currentValue = fstateObject.data.lessThan
                ? fstateObject.data.lessThan
                : "";
              currentValue = fstateObject.data.greaterThan
                ? fstateObject.data.greaterThan
                : "";
              currentValue = fstateObject.data.equalTo
                ? fstateObject.data.equalTo
                : "";
              currentValue = fstateObject.data.greaterThanEqual
                ? fstateObject.data.greaterThanEqual
                : "";
              currentValue = fstateObject.data.lessThanEqual
                ? fstateObject.data.lessThanEqual
                : "";
              currentValue = fstateObject.data.range
                ? fstateObject.data.range
                : "";
              // (currentValue);
              return { id, name: x.name, data: { [v]: currentValue } };
            } else if (meta === "value") {
              const fstateObject = fstate.find((filter) => filter.id === x.id);
              const currentOption = Object.keys(fstateObject.data)[0];
              return { id, name: x.name, data: { [currentOption]: v } };
            } else if (meta === "rangeFrom") {
              const fstateObject = fstate.find((filter) => filter.id === x.id);
              const currentOption = Object.keys(fstateObject.data)[0];
              const currentValue =
                fstateObject.data[Object.keys(fstateObject.data)[0]];
              if (currentValue.includes(",")) {
                const fromValue = currentValue.split(",")[0];
                const toValue = currentValue.split(",")[1];
                const encodedDate = `${v},${toValue}`;
                // ({currentValue, v, fromValue, toValue, encodedDate});
                return {
                  id,
                  name: x.name,
                  data: { [currentOption]: encodedDate },
                };
              } else {
                const encodedDate = `${v},`;
                // (currentValue, v, encodedDate)
                return {
                  id,
                  name: x.name,
                  data: { [currentOption]: encodedDate },
                };
              }
            } else if (meta === "rangeTo") {
              const fstateObject = fstate.find((filter) => filter.id === x.id);
              const currentOption = Object.keys(fstateObject.data)[0];
              const currentValue =
                fstateObject.data[Object.keys(fstateObject.data)[0]];
              if (currentValue.includes(",")) {
                const fromValue = currentValue.split(",")[0];
                const toValue = currentValue.split(",")[1];
                const encodedDate = `${fromValue},${v}`;
                // ({currentValue, v, fromValue, toValue, encodedDate});
                return {
                  id,
                  name: x.name,
                  data: { [currentOption]: encodedDate },
                };
              } else {
                const encodedDate = `,${v}`;
                // (currentValue, v, encodedDate)
                return {
                  id,
                  name: x.name,
                  data: { [currentOption]: encodedDate },
                };
              }
            }
          }
        } else {
          return fstate.find((filter) => filter.id === x.id);
        }
      });
      // (newState, 'am new state');
      return newState;
    });
  };

  const applyFilters = () => {
    setFilterTrue(true);

    const cleanedFilterState = isSelectedData.filter((x) => {
      if (x.options) {
        // for select and radios
        return x.options.length > 0;
      } else if (x.data) {
        // for date
        return (
          x.data.greaterThan ||
          x.data.lessThan ||
          x.data.equalTo ||
          x.data.lessThanEqual ||
          x.data.greaterThanEqual ||
          x.data.range
        );
      } else if (x.value) {
        // for number type
        //x.value is a number u cant get length of it
        return x.value.toString().length > 0;
      }
      // (x);
    });

    localStorage.setItem(
      "cdtuserwiseFilter",
      JSON.stringify(cleanedFilterState)
    );

    setAppliedFilter(cleanedFilterState);
    if (appliedFilter !== 0) {
      appliedFilter.map((x) => {
        if (x.type === "select" || x.type === "radio") {
          const selectFilerobject = {
            id: x.id,
            options: [x.options],
            name: x.name,
          };
          isSelectedData.push(selectFilerobject);
        } else if (x.type === "date" || x.type === "number") {
          // var today = new Date();
          const emptyFilterObject = {
            id: x.id,
            data: {
              equalTo: "",
            },
            name: x.name,
          };
          isSelectedData.push(emptyFilterObject);
        }
      });
    }
    setIsFilterString(getFilterParams());

    // ("filter");
    // props.setOpen(false);
    setIsFilterOpen(false);
    // getData()
  };

  //Copied from prospectOverview
  useEffect(() => {
    setCounter(counter + 1);
    // for removing the stored items in storage
    localStorage.setItem("selectedfiltersdata", isFilterString);
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("selectedinvestorfiltersdata");
    // applyFilters();

    if (myparam && myparam.page) {
      setPage(myparam.page);
      delete myparam.page;
    }
    var getObj = JSON.parse(localStorage.getItem("cdtuserwiseFilter"));
    // ('am local', getObj, isSelectedData);
    // for camparing the two arrays  and adding to the second array
    if (getObj !== null) {
      for (var e = 0; e < isSelectedData.length; e++) {
        if (isSelectedData[e]) {
          for (var f = 0; f < getObj.length; f++) {
            if (isSelectedData[e].id === getObj[f].id) {
              isSelectedData[e].options = getObj[f].options;
              // ("amv", isSelectedData)
            }
          }
        }
      }
      // applyFilters()
      // setIsFilterString(getFilterParams());
      // ('am filter strintv', isFilterString);
    } else {
    }

    if (filterTrue === true) {
      setIsFilterString(getFilterParams());
    }
    // applied filter
    // if (data === true) {
    //   setIsCheckboxSelected([]);
    //   getData();
    // }
    // let filtermatchString = getFilterParams();
    // if (counter >= 2) {
    //   if (filtermatchString === isFilterString) {
    //     getData();
    //   }
    // }
  }, [isFilterString, appliedFilter]); //data

  const shouldNameDisplay = (filter) => {
    // const exceptionCase = location.url
    return filter.showName ? filter.name : "";
  };

  let conversionFormatFor_date = {};

  const getFilterParams = () => {
    const conversionFormatFor_select = {
      Country: "country_id",
      "Demat Accounts Linked": "broker_id",
    };

    myparam === 9
      ? (conversionFormatFor_date = {
          "Signup Date": "createddt__date",
          "Customer Income": "income",
          "Total Invested Value": "investamt",
          "Advise Returns CAGR%": "cagr",
          "Payment Date": "servsigneddt__date",
          "Customer Age": "age",
          "No. Of Advices Given": "no_of_advices_given",
        })
      : (conversionFormatFor_date = {
          "First Investment Date": "firstinvdt",
          "Investment Amount": "investedval",
          "Advised Amount": "advisedval",
          "Current Amount": "currentval",
          Deviation: "deviation",
          "Portfolio Return": "gainper",
          "Advised Amount": "totalinvestedval",
        });

    const conversionFormatFor_number = {
      // "Advise Returns CAGR%": "cagr",
      // "Customer Income": "income",
      // "No. Of Advices Given": "no_of_advices_given",
    };

    const filterParams = {};
    // (filterParams);

    appliedFilter.map((filter) => {
      if (filter.options) {
        // condition it based on type of filter rather than options or data props

        filterParams[conversionFormatFor_select[filter.name]] = filter.options
          .map((x) => x)
          .join(",");
      } else if (filter.data) {
        let suffix;
        if (Object.keys(filter.data)[0] === "greaterThan") {
          suffix = "__gt";
        } else if (Object.keys(filter.data)[0] === "lessThan") {
          suffix = "__lt";
        } else if (Object.keys(filter.data)[0] === "equalTo") {
          suffix = "";
        } else if (Object.keys(filter.data)[0] === "lessThanEqual") {
          suffix = "__lte";
        } else if (Object.keys(filter.data)[0] === "greaterThanEqual") {
          suffix = "__gte";
        } else if (Object.keys(filter.data)[0] === "range") {
          suffix = "__range";
        }
        // (filter);
        // (Object.keys(filter.data)[0]);
        filterParams[conversionFormatFor_date[filter.name] + suffix] =
          filter.data[Object.keys(filter.data)[0]];
      }
      //  else if (filter.value) {
      //   filterParams[conversionFormatFor_number[filter.name]] = filter.value;
      // }
    });
    //return the query string with the filterParams
    // (("&"+Object.keys(filterParams).map(x=>x+"="+filterParams[x]).join('&')));
    const params = Object.keys(filterParams)
      .map((x) => x + "=" + filterParams[x])
      .join("&");
    return params ? "&" + params : "";
  };
  const clearFilters = () => {
    setIsSelectedDatas([
      {
        id: 1,
        options: [],
        name: "Country",
      },
      {
        id: 2,
        options: [],
        name: "Demat Accounts Linked",
      },
      {
        id: 3,
        data: { equalTo: "" },
        name: "Signup Date",
      },
      {
        id: 4,
        data: { equalTo: "" },
        name: "Customer Income",
      },

      {
        id: 5,
        data: { equalTo: "" },
        name: "Total Invested Value",
      },
      {
        id: 6,
        data: { equalTo: "" },
        name: "Advise Returns CAGR %",
      },
      {
        id: 7,
        data: { equalTo: "" },
        name: "Payment Date",
      },
      {
        id: 8,
        data: { equalTo: "" },
        name: "Customer Age",
      },
      {
        id: 9,
        data: { equalTo: "" },
        name: "No. Of Advices Given",
      },
    ]);
    localStorage.removeItem("selectedinvestorfiltersdata");
    localStorage.removeItem("cdtuserwiseFilter");
  };
  // (columns);
  const parseRangeValue = (doubleDate, fromTo) => {
    if (fromTo === "from") {
      return doubleDate.split(",")[0];
    } else {
      return doubleDate.split(",")[1];
    }
  };

  // FILTER ENDS
  //

  const [showGlobalReport, setGlobalReport] = useState([
    {
      headerName: "Date",
      id: "date",
      show: true,
      minWidth: 180,
      type: "date",
      align: "center",
    },
    {
      headerName: "No.of Website registrations",
      id: "web_reg",
      show: true,
      minWidth: 180,
      align: "center",

      // minWidth: 200,
    },
    {
      headerName: "No of app downloads ",
      id: "app_downloads",
      show: true,
      minWidth: 180,
      align: "center",

      // minWidth: 200,
    },
    {
      headerName: "no of registered ",
      id: "registered",
      show: true,
      minWidth: 180,
      align: "center",

      // minWidth: 200,
    },
    {
      headerName: "no of unregistered",
      id: "unregistered",
      show: true,
      minWidth: 180,
      align: "center",

      // minWidth: 200,
    },
    {
      headerName: "Clicked on subscribe and choose savart X and not paid",
      id: "savartx_unpaid",
      show: true,
      minWidth: 220,
      align: "center",

      // minWidth: 200,
    },
    {
      headerName: "Clicked on subscribe and choose savart 3X and not paid",
      id: "savartx3_unpaid",
      show: true,
      minWidth: 220,
      align: "center",

      // minWidth: 200,
    },
    {
      headerName: "Clicked on scbscribe and choose savart X and paid",
      id: "savartx",
      show: true,
      minWidth: 220,
      align: "center",
    },
    {
      headerName: "Clicked on scbscribe and choose savart 3X and paid",
      id: "savartx3",
      show: true,
      align: "center",

      minWidth: 220,
    },
  ]);

  const [showAdviceTracking, setAdviceTracking] = useState([
    {
      headerName: "Date",
      id: "date",
      show: true,
      // minWidth: 200,
      type: "date",
      align: "center",
    },
    {
      headerName: "Advises Sent",
      id: "advises_sent",
      show: true,
      align: "center",

      // minWidth: 200,
    },
    {
      headerName: "Pending requests",
      id: "pending_requests",
      show: true,
      align: "center",

      // minWidth: 200
    },
    {
      headerName: "Total requests",
      id: "total_requests",
      show: true,
      align: "center",

      // minWidth: 200
    },
    {
      headerName: "India Amount",
      id: "ind_amt",
      show: true,
      align: "center",

      // minWidth: 200
    },
    {
      headerName: "USA Amount",
      id: "usa_amt",
      show: true,
      align: "center",

      // minWidth: 200
    },
    {
      headerName: "Canada Amount",
      id: "cad_amt",
      show: true,
      align: "center",

      // minWidth: 200
    },
  ]);

  const [adviceVsCustomers, setAdviceVsCustomers] = useState([
    {
      headerName: "Date",
      id: "date",
      show: true,
      align: "center",

      // minWidth: 200,
      type: "date",
    },
    {
      headerName: "Advises Sent",
      id: "advises_sent",
      show: true,
      align: "center",

      // minWidth: 200
    },
    {
      headerName: "Greater Than Tewelve",
      id: "greater_than_tewelve",
      show: true,
      align: "center",
      type: "link",
      // minWidth: 200
    },
    {
      headerName: "Zero Advises",
      id: "zero_advises",
      show: true,
      align: "center",

      // minWidth: 200
    },
  ]);

  const [brokerLinkingStatus, setBrokerLinkingStatus] = useState([
    {
      headerName: "Date",
      id: "date",
      show: true,
      align: "center",

      // minWidth: 200,
      type: "date",
    },
    {
      headerName: "One Broker",
      id: "one_broker",
      show: true,
      align: "center",

      // minWidth: 200
    },
    {
      headerName: "Multiple Broker",
      id: "mutliple_broker",
      show: true,
      align: "center",

      // minWidth: 200
    },
    {
      headerName: "Non Linked",
      id: "nonlinked",
      show: true,
      align: "center",

      // minWidth: 200
    },
  ]);
  const [decisionMaking, setDecisionMakingChildColumn] = useState([
    {
      headerName: "Dates",
      id: "dates",
      show: true,
      align: "center",
      minWidth: 200,
      type: "date",
    },
    {
      headerName: "Week",
      id: "week",
      show: true,
      minWidth: 200,
      align: "center",
      // format: "Date"
    },
    {
      id: "Monday",
      headerName: "Monday",
      show: true,
      minWidth: 200,
      align: "center",
      type: "link",
    },
    {
      id: "Tuesday",
      headerName: "Tuesday",
      show: true,
      minWidth: 200,
      align: "center",
    },
    {
      id: "Wednesday",
      headerName: "Wednesday",
      show: true,
      minWidth: 200,
      align: "center",
    },

    {
      headerName: "Thursday",
      id: "Thursday",
      show: true,
      minWidth: 150,
      align: "center",
      // format: "Date"
    },
    {
      headerName: "Friday",
      id: "Friday",
      show: true,
      minWidth: 150,
      align: "center",
    },
    {
      headerName: "Saturday",
      id: "Saturday",
      show: true,
      minWidth: 150,
      align: "center",
    },
    {
      headerName: "Sunday",
      id: "Sunday",
      show: true,
      minWidth: 150,
      align: "center",
    },
  ]);

  const [onboardingCompletionColumns, setOnboardingCompletionColumns] =
    useState([
      {
        headerName: "Date",
        id: "date",
        show: true,
        minWidth: 200,
        // headerAlign: "center",
        align: "center",
      },
      {
        headerName: "No.of completed",
        id: "completed",
        show: true,
        minWidth: 150,
        type: "link",
        // headerAlign: "center",
        align: "center",
      },
      {
        headerName: "No.of pending from same day subscribers",
        id: "same_day_pending",
        show: true,
        minWidth: 150,
        type: "link",

        // headerAlign: "center",
        align: "center",
      },
      {
        headerName: "Other Days Pending",
        id: "others_day_pending",
        show: true,
        minWidth: 200,
        type: "link",

        // headerAlign: "center",
        align: "center",
      },
    ]);

  const [investorAgeColumns, setInvestorAgeColumns] = useState([
    {
      headerName: "Date",
      id: "date",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },

    {
      headerName: "0 to 30 days",
      id: "-30",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "30 to 90 days",
      id: "31-90",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Above 90 days",
      id: "90+",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
  ]);
  const [daysToRenewalColumns, setDaysToRenewalColumns] = useState([
    {
      headerName: "Date",
      id: "date",
      show: true,
      minWidth: 150,

      // type: "link"
      // headerAlign: "center",
      align: "center",
    },

    {
      headerName: "below 30 days",
      id: "-30",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "90 to 30 days",
      id: "91-30",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Above 90 days",
      id: "90+",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
  ]);
  const [clientWithZeroAdvicesColumns, setClientWithZeroAdvicesColumns] =
    useState([
      {
        headerName: "Date",
        id: "date",
        show: true,
        minWidth: 150,

        // type: "link"
        // headerAlign: "center",
        align: "center",
      },

      {
        headerName: "below 30 days",
        id: "-30",
        show: true,
        minWidth: 150,
        type: "link",

        // headerAlign: "center",
        align: "center",
      },
      {
        headerName: "90 to 30 days",
        id: "91-30",
        show: true,
        minWidth: 150,
        type: "link",

        // headerAlign: "center",
        align: "center",
      },
      {
        headerName: "Above 90 days",
        id: "90+",
        show: true,
        minWidth: 150,
        type: "link",

        // headerAlign: "center",
        align: "center",
      },
    ]);

  const [userwiseData, setuserwiseData] = useState([
    {
      headerName: "User ID",
      id: "userid",
      show: true,
      minWidth: 150,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Mobile Number",
      id: "mobile",
      show: true,
      minWidth: 150,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },

    {
      headerName: "Country",
      id: "country",
      show: true,
      minWidth: 150,
      format: "array",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Signup Date",
      id: "signupdate",
      show: true,
      minWidth: 150,
      format: "Date",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "First Payment Date",
      id: "first_payment_date",
      show: true,
      minWidth: 150,
      format: "Date",
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Last Payment Date",
      id: "last_payment_date",
      show: true,
      minWidth: 150,
      format: "Date",
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "No. of Advices Given",
      id: "total_advices",
      show: true,
      minWidth: 150,
      type: "number",
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total Amount of Advice Sent",
      id: "totaladvisedval",
      show: true,
      minWidth: 150,
      type: "number",
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Advice Portfolio Returns Till Now",
      id: "advice_gain",
      show: true,
      minWidth: 150,
      type: "number",
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: <span>Advice Returns CAGR&nbsp;%</span>,
      id: "advice_cagr",
      show: true,
      minWidth: 150,
      type: "number",
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total Invested Value",
      id: "totalinvestedval",
      show: true,
      minWidth: 150,
      type: "number",
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Invested Portfolio Returns Till Now",
      id: "invested_gain",
      show: true,
      minWidth: 150,
      type: "number",
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: (
        <span>
          <span style={{ fontSize: "15px", color: "blue", fontWeight: "700" }}>
            *
          </span>{" "}
          Invested returns CAGR&nbsp;%
        </span>
      ),
      id: "invested_cagr",
      show: true,
      minWidth: 150,
      type: "number",
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Demat Accounts Linked ",
      id: "linked_accounts",
      show: true,
      minWidth: 150,
      format: "array",
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Customer Age",
      id: "customer_age",
      show: true,
      minWidth: 150,
      type: "number",
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Customer Income",
      id: "customer_income",
      show: true,
      minWidth: 150,
      type: "number",
      // headerAlign: "center",
      align: "center",
    },
  ]);

  const [showApiData, setApiData] = useState([
    {
      id: 0,
      apiname: "globalReport",
      columName: showGlobalReport,
    },
    {
      id: 1,
      apiname: "adviseTracking",
      columName: showAdviceTracking,
    },
    {
      id: 2,
      apiname: "adviseVsCustomers",
      columName: adviceVsCustomers,
    },
    {
      id: 3,
      apiname: "brokerLinkingStatus",
      columName: brokerLinkingStatus,
    },
    {
      id: 4,
      apiname: "decision_making_child",
      columName: decisionMaking,
    },
    {
      id: 5,
      apiname: "onboardingCompletion",
      columName: onboardingCompletionColumns,
    },
    {
      id: 6,
      apiname: "investors_age",
      columName: investorAgeColumns,
    },
    {
      id: 7,
      apiname: "renewal_age",
      columName: daysToRenewalColumns,
    },
    {
      id: 8,
      apiname: "inactive",
      columName: clientWithZeroAdvicesColumns,
    },
    {
      id: 9,
      apiname: "cdt_userwise",
      columName: userwiseData,
    },
    {
      id: 10,
      // apiname: "cdt_userwise",
      // columName: userwiseData,
    },
  ]);

  const [getApiNAme, setApiName] = useState("");
  const [filterString, setFilterString] = useState("");
  // (filterString);

  const myparam = location.state;
  const receiveDataName = location.cardName;

  const getPaginationURL = (url, newQuery) => {
    const query = newQuery ? newQuery : searched;

    // var selectedRows=[...datas];
    // ('am datas', selectedRows);

    var retrievedObject = localStorage.getItem("testObject");
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&emp_id=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };

  // Sorts columns with numeric values and strings
  const handleRequestSort = (e, property, format) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = [];
    if (format === "numeric") {
      // Use parseInt to parse string to numbers for numeric sorting
      finalRows = tempRows.sort((a, b) =>
        isAsc
          ? parseInt(a[property]) - parseInt(b[property])
          : parseInt(b[property]) - parseInt(a[property])
      );
    } else {
      finalRows = tempRows.sort((a, b) => {
        if (
          typeof a[property] === "string" &&
          typeof b[property] === "string"
        ) {
          return isAsc
            ? a[property].localeCompare(b[property])
            : b[property].localeCompare(a[property]);
        } else {
          return isAsc ? a[property] - b[property] : b[property] - a[property];
        }
      });
    }
    setRows(finalRows);
    setPage(0);
  };

  const getData = (newQuery) => {
    // showApiData.map((item, index) => {
    //     if (item.id === receiveData) {
    //         setApiName(item.apiname);
    //     }
    // })

    // showApiData.map((item, index) => {
    //     if (item.id === receiveData) {
    //         setColumns(item.columName);
    //     }
    // })

    const baseURL = uniqueApiNames.apiname;
    // setOriginalRows([]);
    setRows([]);

    http
      .get(getPaginationURL(baseURL, newQuery) + isFilterString)
      .then((res) => {
        toast.dismiss();
        // (res.data.data);
        if (
          res &&
          res.data &&
          res.data.statusCode === 0 &&
          Array.isArray(res.data.data)
        ) {
          let tempDta = res.data.data;
          let finalrows = tempDta.map((item) => {
            // (item);
            const obj = item;
            // (obj);

            const swapValue = (obj) => {
              Object.keys(obj).forEach((key) => {
                // if (!obj[key]) {
                //     obj[key] = "N/A";
                // }
              });
            };
            swapValue(obj);
            // (obj);
            return item;
          });

          let tempRows = [];
          // let tempTasks = tempDta.map(item=>item.custtasks);
          // setCustTask(tempTasks);

          let finalData = [];
          let tempStatusDta = tempDta.map((item, index) => {
            const swapValue = (item) => {
              Object.keys(item).forEach((key) => {
                //(Object.keys(item));
                // if (!item[key]) {
                //     item[key] = "N/A";
                // }
              });
            };
            swapValue(item);

            // arr.splice(1, arr.length - 2);

            return item;
          });

          //UserwiseData Filter
          if (myparam === 9) {
            const datas = res.data.filter;
            let rawData = datas.map((es, index) => {
              es.id = index + 1;
              return es;
            });

            setIsFilterData(rawData);
          }

          setOriginalRows(tempDta);
          // setRows(res.data.data);

          // setOriginalRows(tempDta);
          setRows(tempDta);
          toast.dismiss();
          setTotalRowCount(res.data.totalRowCount);
        }
      });
  };

  console.log(myparam);

  useEffect(() => {
    if (myparam === 4) {
      employeesListData();
    }

    if (myparam === 9) {
      setFilters(true);
    }
    toast.loading("Please wait...");
    const uniqueColumns = showApiData.filter((ele) => {
      return ele.id === myparam;
    });
    setColumns(uniqueColumns[0].columName);

    uniqueApiNames = uniqueColumns[0];

    getData();
  }, [page, rowsPerPage, isFilterString]); //totalRowCount

  const employeesListData = () => {
    http
      .get("employee_list")
      .then((res) => {
        // firstEmployeeList = res.data.rmnames[0].id
        let employeesList = [
          {
            id: "all",
            empfname: "All",
          },
        ];
        let allEmployeesList = res.data.rmnames;
        setEmployeesList([...employeesList, ...allEmployeesList]);
        // setMultipleProspect(res.data.rms);
      })
      .catch((err) => {});
  };

  const gotoMisSalaesReportsCards = () => {
    localStorage.removeItem("cdtuserwiseFilter");
    history.push({
      pathname: viewSalesMisReportsPath,
    });
  };

  const [showFilter, setShowFilter] = useState(false);

  // const viewProspectDetails = (date, country) => {

  //     const sendToparticularCDT = {
  //         "date": date,
  //         "country": country
  //     }
  //     const sendToyetToSubscribeCDT = {
  //         "date": date,
  //         // "country": country

  //     }
  //     history.push(
  //         {
  //             pathname: viewmissalesreportsdetailsPath,
  //             state: sendToyetToSubscribeCDT,
  //             columnId: uniqueApiNames.id,
  //             cardName: location.cardName,
  //             employeeId: firstEmployeeList
  //         },
  //         "_blank"
  //     );
  // };

  const viewProspectDetails = (row, id) => {
    // object.page = page;
    const sendToparticularCDT = {
      date: row.date,
      country: id,
    };
    const sendToyetToSubscribeCDT = {
      date: row.date,
    };
    if (row.country === "ref_generated" || row.country === "yet_to_sub") {
      history.push(
        {
          pathname: ViewCDTyetToSubscribePath,
          state: sendToyetToSubscribeCDT,
          columnId: uniqueApiNames.id,
          cardName: location.cardName,
        },
        "_blank"
      );
    } else {
      history.push(
        {
          pathname: ViewCdtParticularPath,
          state: sendToparticularCDT,
          columnId: uniqueApiNames.id,
          cardName: location.cardName,
        },
        "_blank"
      );
    }
  };

  const showMenuFilter = () => {
    setShowFilter((val) => !val);
  };

  // const closeFilter = () => {
  //   setShowFilter(false);
  // };

  const [filterVal, setFilterVal] = useState({
    fromDate: "",
    toDate: "",
  });

  const { fromDate, toDate } = filterVal;

  // (filterVal);
  // (fromDate, "asdfgh", toDate);

  const handleChange = (e) => {
    setFilterVal({ ...filterVal, [e.target.name]: e.target.value });
  };

  var string = "&fromdate=" + fromDate + "&todate=" + toDate;
  // const applyFilter = () => {
  //   setFilterString(string);
  // };
  // const[empty,setempty]=useState({});

  // const clearFilter = () => {
  //   var date_input = document.getElementById("fromDate");
  //   date_input.value = "";

  //   setFilterString("");
  //   // setFilterVal(empty);

  //   // setempty(true);
  //   // (empty);
  //   setFilterVal({
  //     ...filterVal,
  //     fromDate: "",
  //     toDate: "",
  //   });
  //   // setFilterVal(prevState => ({
  //   //     ...prevState,
  //   //  }));
  //   setFilterVal({});
  // };
  const handleLangChange = (e) => {
    setSelectedEmplloyeeName(e.target.value);
  };

  const postRmNamesList = () => {
    if (selectedEmployeeName === "all") {
      getData();
    } else if (selectedEmployeeName !== "") {
      getData(selectedEmployeeName);
    } else {
      toast.error("Please select the RM Names list");
    }
  };

  // Date

  return (
    <>
      <Grid container style={{ marginBlock: "20px" }}>
        <Grid item xs>
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={gotoMisSalaesReportsCards}
          >
            Back
          </Button>
        </Grid>
        <Grid item xs style={{ textAlign: "center" }}>
          <Typography variant="h5">{receiveDataName}</Typography>
        </Grid>
        <Grid item xs></Grid>
      </Grid>

      <Paper className={classes.root}>
        <Grid container style={{ justifyContent: "space-between", padding: 5 }}>
          {myparam === 9 ? (
            ""
          ) : (
            <Grid item>
              <SearchBar
                value={searched}
                onChange={(searchVal) => requestSearch(searchVal)}
                onCancelSearch={() => cancelSearch()}
                // className={"mt30"}
              />
            </Grid>
          )}

          <Grid item>
            <Grid container style={{ alignItems: "center" }}>
              {location.name === 4 ? (
                <>
                  <FormControl>
                    <Select
                      displayEmpty
                      labelId="statusLable"
                      id="statusSelect"
                      MenuProps={MenuProps}
                      variant="outlined"
                      className={classes.select}
                      value={selectedEmployeeName ? selectedEmployeeName : ""}
                      onChange={handleLangChange}
                      style={{
                        width: "220px",
                        height: "47px",
                      }}
                    >
                      <MenuItem value=""> RMNames List</MenuItem>
                      {employeesList.map((option) => {
                        return (
                          <MenuItem value={option.id} key={option.id}>
                            {option.empfname}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </>
              ) : (
                ""
              )}
              {location.name === 4 ? (
                <Grid item sm={6} md={2} xs={false}>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: 10, borderRadius: 60 }}
                    //  startIcon={<AddCircleOutlineIcon />}
                    className={"addBtn"}
                    onClick={postRmNamesList}
                  >
                    View
                  </Button>
                </Grid>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
          <Grid item>
            <TablePagination
              rowsPerPageOptions={[10, 50, 100, 500]}
              component="div"
              // count={orignalRows.length}
              count={myparam === 9 ? totalRowCount : orignalRows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              // style={{width:'27rem'}}
            />
          </Grid>
          {Filters ? (
            <Grid
              item
              style={{ display: "flex", position: "relative" }}
              className="tfilter"
            >
              Filter
              <Grid item>
                <SvgIcon
                  style={{ cursor: "pointer", verticalAlign: "middle" }}
                  onClick={openFilter}
                  title={"filter"}
                >
                  <FilterLogo />
                </SvgIcon>
              </Grid>
            </Grid>
          ) : (
            ""
          )}
        </Grid>

        {isFilterOpen ? (
          <div
            className={["newfilterstyle", "menupopupfilter", "filter"].join(
              " "
            )}
          >
            {/* {('am fun', isSelectedData)} */}
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                lineHeight: "30px",
                display: "flex",
                justifyContent: "center",
                fontWeight: "bold",
                cursor: "pointer",
                background: "#ddd",
                margin: "5px 0 0 5px",
              }}
              onClick={closeFilter}
            >
              X
            </div>
            <div
              style={{
                float: "right",
                paddingBottom: 10,
                paddingRight: 40,
                paddingTop: 10,
                display: "flex",
                justifyContent: "flex-end",
                columnGap: 20,
              }}
            >
              <Button
                variant="contained"
                onClick={clearFilters}
                color="default"
              >
                Clear
              </Button>
              <Button
                variant="contained"
                onClick={applyFilters}
                color="primary"
              >
                Apply
              </Button>
            </div>
            {isFilterData.map((filter, index) => {
              return (
                <div
                  key={index}
                  style={{
                    marginLeft: 20,
                    paddingBottom: 10,
                    paddingTop: 10,
                  }}
                >
                  <div>
                    <InputLabel style={{ color: "black" }}>
                      {shouldNameDisplay(filter)}
                    </InputLabel>
                  </div>
                  {/* {isSelectedData.map((es) => {
                          return (
                            <>
                              {es.sno} am state
                            </>
                          )
                        })} */}

                  <div style={{ paddingTop: 10 }}>
                    {filter.type === "select" && filter.showName == true ? (
                      <>
                        <Select
                          labelId="mutiple-select-label"
                          displayEmpty
                          className="select"
                          variant="outlined"
                          multiple
                          value={
                            isSelectedData.find((x) => {
                              return x.id === filter.id;
                            })?.options || []
                          }
                          name={filter.name}
                          onChange={(e) => {
                            handleSelectChange(e.target.value, filter.id);
                          }}
                          // renderValue={(selectedDatas) => selectedDatas.join(", ")}
                          renderValue={(selected) => {
                            return selected
                              .map(
                                (s) =>
                                  filter.options.find((x) => x.value === s)
                                    ?.name
                              )
                              .join(", ");
                          }}

                          // MenuProps={MenuProps}
                        >
                          {filter.options.map((option, index) => (
                            <MenuItem key={index} value={option.value}>
                              <ListItemText primary={option.name} />
                              <ListItemIcon>
                                <Checkbox
                                  classes={{
                                    root: classes.radio,
                                    checked: classes.checked,
                                  }}
                                  checked={
                                    isSelectedData
                                      .find((x) => x.id === filter.id)
                                      ?.options.indexOf(option.value) !== -1
                                      ? true
                                      : false
                                  }
                                />
                              </ListItemIcon>
                            </MenuItem>
                          ))}
                        </Select>
                      </>
                    ) : filter.type === "radio" && filter.showName == true ? (
                      <>
                        <Select
                          displayEmpty
                          value={
                            isSelectedData.find((x) => {
                              return x.id === filter.id;
                            })?.options
                          }
                          onChange={(e) => {
                            handleSelectChange(e.target.value, filter.id);
                          }}
                          name={filter.name}
                          className="select"
                          variant="outlined"
                          multiple
                          style={{
                            backgroundColor: "white",
                          }}
                        >
                          <MenuItem value="">Select</MenuItem>
                          {filter.options.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option.value}>
                                <ListItemText primary={option.name} />
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </>
                    ) : filter.type === "date" && filter.showName == true ? (
                      <>
                        <select
                          value={
                            Object.keys(
                              isSelectedData.find((x) => {
                                return x.id === filter.id;
                              })?.data || {}
                            )[0]
                          }
                          onChange={(x) =>
                            handleSelectChange(
                              x.target.value,
                              filter.id,
                              "option"
                            )
                          }
                          className="select"
                          label={filter.name}
                          style={{
                            backgroundColor: "white",
                            marginBottom: 10,
                          }}
                        >
                          <option value={"equalTo"}>Equal To</option>
                          <option value={"lessThan"}>Less Than</option>
                          <option value={"greaterThan"}>Greater Than</option>
                          <option value={"lessThanEqual"}>
                            Less Than Equal To
                          </option>
                          <option value={"greaterThanEqual"}>
                            Greater Than Equal To
                          </option>
                          <option value={"range"}>Range</option>
                        </select>
                        {Object.keys(
                          isSelectedData.find((x) => {
                            return x.id === filter.id;
                          })?.data || {}
                        )[0] !== "range" ? (
                          <TextField
                            type="date"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              max: new Date().toISOString().slice(0, 10), // Add this line
                            }}
                            value={
                              isSelectedData.find((x) => x.id === filter.id)
                                ?.data[
                                Object.keys(
                                  isSelectedData.find((x) => x.id === filter.id)
                                    ?.data || {}
                                )[0]
                              ]
                            }
                            onChange={(x) =>
                              handleSelectChange(
                                x.target.value,
                                filter.id,
                                "value"
                              )
                            }
                            className="select"
                            style={{
                              backgroundColor: "white",
                            }}
                          />
                        ) : (
                          // RANGE FIELDS
                          // <>
                          //   <label
                          //     style={{
                          //       fontSize: 11,
                          //       marginBorrom: 10,
                          //       display: "block",
                          //     }}
                          //   >
                          //     {" "}
                          //     From{" "}
                          //   </label>
                          //   <TextField
                          //     type="date"
                          //     variant="outlined"
                          //     InputLabelProps={{
                          //       shrink: true,
                          //     }}
                          //     inputProps={{
                          //       max: new Date().toISOString().slice(0, 10), // Add this line
                          //     }}
                          //     value={parseRangeValue(
                          //       isSelectedData.find((x) => x.id === filter.id)
                          //         ?.data[
                          //         Object.keys(
                          //           isSelectedData.find(
                          //             (x) => x.id === filter.id
                          //           )?.data || {}
                          //         )[0]
                          //       ],
                          //       "from"
                          //     )}
                          //     onChange={(x) =>
                          //       handleSelectChange(
                          //         x.target.value,
                          //         filter.id,
                          //         "rangeFrom"
                          //       )
                          //     }
                          //     className="select"
                          //     style={{
                          //       backgroundColor: "white",
                          //     }}
                          //   />
                          //   <label
                          //     style={{
                          //       fontSize: 11,
                          //       marginBorrom: 10,
                          //       display: "block",
                          //     }}
                          //   >
                          //     {" "}
                          //     To{" "}
                          //   </label>
                          //   <TextField
                          //     type="date"
                          //     variant="outlined"
                          //     InputLabelProps={{
                          //       shrink: true,
                          //     }}
                          //     inputProps={{
                          //       max: new Date().toISOString().slice(0, 10), // Add this line
                          //     }}
                          //     value={parseRangeValue(
                          //       isSelectedData.find((x) => x.id === filter.id)
                          //         ?.data[
                          //         Object.keys(
                          //           isSelectedData.find(
                          //             (x) => x.id === filter.id
                          //           )?.data || {}
                          //         )[0]
                          //       ],
                          //       "to"
                          //     )}
                          //     onChange={(x) =>
                          //       handleSelectChange(
                          //         x.target.value,
                          //         filter.id,
                          //         "rangeTo"
                          //       )
                          //     }
                          //     className="select"
                          //     style={{
                          //       backgroundColor: "white",
                          //     }}
                          //   />
                          // </>
                          <>
                            <label
                              style={{
                                fontSize: 11,
                                marginBottom: 10,
                                display: "block",
                              }}
                            >
                              From
                            </label>
                            <TextField
                              type="date"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                max: new Date().toISOString().slice(0, 10),
                              }}
                              value={parseRangeValue(
                                isSelectedData.find((x) => x.id === filter.id)
                                  ?.data[
                                  Object.keys(
                                    isSelectedData.find(
                                      (x) => x.id === filter.id
                                    )?.data || {}
                                  )[0]
                                ],
                                "from"
                              )}
                              onChange={(x) =>
                                handleSelectChange(
                                  x.target.value,
                                  filter.id,
                                  "rangeFrom"
                                )
                              }
                              className="select"
                              style={{
                                backgroundColor: "white",
                              }}
                            />
                            <label
                              style={{
                                fontSize: 11,
                                marginBottom: 10,
                                display: "block",
                              }}
                            >
                              To
                            </label>
                            <TextField
                              type="date"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                max: new Date().toISOString().slice(0, 10),
                                // Add this line to set min value equal to the value of first date field
                                min: parseRangeValue(
                                  isSelectedData.find((x) => x.id === filter.id)
                                    ?.data[
                                    Object.keys(
                                      isSelectedData.find(
                                        (x) => x.id === filter.id
                                      )?.data || {}
                                    )[0]
                                  ],
                                  "from"
                                ),
                              }}
                              value={parseRangeValue(
                                isSelectedData.find((x) => x.id === filter.id)
                                  ?.data[
                                  Object.keys(
                                    isSelectedData.find(
                                      (x) => x.id === filter.id
                                    )?.data || {}
                                  )[0]
                                ],
                                "to"
                              )}
                              onChange={(x) =>
                                handleSelectChange(
                                  x.target.value,
                                  filter.id,
                                  "rangeTo"
                                )
                              }
                              className="select"
                              style={{
                                backgroundColor: "white",
                              }}
                            />
                          </>
                        )}
                      </>
                    ) : filter.type === "number" && filter.showName == true ? (
                      <>
                        <select
                          value={
                            Object.keys(
                              isSelectedData.find((x) => {
                                return x.id === filter.id;
                              })?.data || {}
                            )[0]
                          }
                          onChange={(x) =>
                            handleSelectChange(
                              x.target.value,
                              filter.id,
                              "option"
                            )
                          }
                          className="select"
                          label={filter.name}
                          style={{
                            backgroundColor: "white",
                            marginBottom: 10,
                          }}
                        >
                          <option value={"equalTo"}>Equal To</option>
                          <option value={"lessThan"}>Less Than</option>
                          <option value={"greaterThan"}>Greater Than</option>
                          <option value={"lessThanEqual"}>
                            Less Than Equal To
                          </option>
                          <option value={"greaterThanEqual"}>
                            Greater Than Equal To
                          </option>
                          <option value={"range"}>Range</option>
                        </select>
                        {/* {// ('test1', filter.id)}
                  {// (filterState.find(x=>{// (x);return x.id===filter.id}))}
                  {// ('test2')} */}
                        {Object.keys(
                          isSelectedData.find((x) => {
                            return x.id === filter.id;
                          })?.data || {}
                        )[0] !== "range" ? (
                          <TextField
                            type="text"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={
                              isSelectedData.find((x) => x.id === filter.id)
                                ?.data[
                                Object.keys(
                                  isSelectedData.find((x) => x.id === filter.id)
                                    ?.data || {}
                                )[0]
                              ]
                            }
                            onChange={(x) =>
                              handleSelectChange(
                                x.target.value,
                                filter.id,
                                "value"
                              )
                            }
                            className="select"
                            style={{
                              backgroundColor: "white",
                            }}
                          />
                        ) : (
                          // RANGE FIELDS
                          <>
                            <label
                              style={{
                                fontSize: 11,
                                marginBorrom: 10,
                                display: "block",
                              }}
                            >
                              {" "}
                              From{" "}
                            </label>
                            <TextField
                              type="text"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={parseRangeValue(
                                isSelectedData.find((x) => x.id === filter.id)
                                  ?.data[
                                  Object.keys(
                                    isSelectedData.find(
                                      (x) => x.id === filter.id
                                    )?.data || {}
                                  )[0]
                                ],
                                "from"
                              )}
                              onChange={(x) =>
                                handleSelectChange(
                                  x.target.value,
                                  filter.id,
                                  "rangeFrom"
                                )
                              }
                              className="select"
                              style={{
                                backgroundColor: "white",
                              }}
                            />
                            <label
                              style={{
                                fontSize: 11,
                                marginBorrom: 10,
                                display: "block",
                              }}
                            >
                              {" "}
                              To{" "}
                            </label>
                            <TextField
                              type="text"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={parseRangeValue(
                                isSelectedData.find((x) => x.id === filter.id)
                                  ?.data[
                                  Object.keys(
                                    isSelectedData.find(
                                      (x) => x.id === filter.id
                                    )?.data || {}
                                  )[0]
                                ],
                                "to"
                              )}
                              onChange={(x) =>
                                handleSelectChange(
                                  x.target.value,
                                  filter.id,
                                  "rangeTo"
                                )
                              }
                              className="select"
                              style={{
                                backgroundColor: "white",
                              }}
                            />
                          </>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          ""
        )}

        {/* {showFilter ? (
          <div className="filterbg">
            <div style={{ textAlign: "right" }}>
              <CancelOutlinedIcon
                onClick={closeFilter}
                style={{ marginTop: "100px" }}
              />
            </div>
            <div>
              <h1>Date</h1>
              <label>From</label>
              <br />
              <br />
              <input
                type="date"
                id="fromDate"
                name="fromDate"
                onChange={handleChange}
              />
              <br />
              <br />
              <br />
              <label>To</label>
              <br />
              <br />
              <input type="date" name="toDate" onChange={handleChange} />
              <br />
              <br />
              <br />
              <br />
              <div className="btnsfilter">
                <button onClick={applyFilter}>Apply</button>
                <button onClick={clearFilter}>Clear</button>
              </div>
            </div>
          </div>
        ) : null} */}

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* {columns.map(item => {
                                    return (
                                        <TableCell>{item.headerName}</TableCell>
                                    )
                                })} */}
                {columns.map((column, index) => (
                  <TableCell
                    key={index}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="prospect_table"
                  >
                    {column.id === "invested_cagr" ? (
                      <Tooltip
                        title="This data is calculated as per the information available in our database"
                        arrow
                      >
                        <TableSortLabel
                          active={orderBy === column.id}
                          direction={order === "asc" ? "desc" : "asc"}
                          onClick={(e) =>
                            handleRequestSort(e, column.id, column.format)
                          }
                          orderBy={orderBy}
                          order={order}
                        >
                          {column.headerName}
                        </TableSortLabel>
                      </Tooltip>
                    ) : (
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={order === "asc" ? "desc" : "asc"}
                        onClick={(e) =>
                          handleRequestSort(e, column.id, column.format)
                        }
                        orderBy={orderBy}
                        order={order}
                      >
                        {column.headerName}
                      </TableSortLabel>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length !== 0 ? (
                <>
                  {rows.map((row, index) => {
                    return (
                      <TableRow hover className="prospecttable">
                        {columns.map((column, index) => {
                          const value = row[column.id];

                          return (
                            <TableCell
                              key={index}
                              align={column.align}
                              // onDoubleClick={() => viewProspectDetails(row)}
                            >
                              {column.format && typeof value === "number" ? (
                                column.format(value)
                              ) : column.format === "array" ? (
                                Array.isArray(value) && value.length !== 0 ? (
                                  <>{value.join(", ")}</>
                                ) : (
                                  "N/A"
                                )
                              ) : column.id === "type" && value.length !== 0 ? (
                                <>
                                  {Array.isArray(value)
                                    ? value.join(",")
                                    : "N/A"}
                                </>
                              ) : column.format === "Date" ? (
                                getDate(value)
                              ) : column.operation &&
                                column.operation === "concate" ? (
                                value + column.operand + row[column.with]
                              ) : column.type &&
                                column.type === "link" &&
                                value ? (
                                <p
                                  style={{
                                    margin: "0px",
                                    padding: "18px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                  }}
                                  variant="body2"
                                  // onClick={(e) => viewDetails(row)}
                                  // onDoubleClick={(e) => viewProspectDetails(row.weekNo, row.weekCount)}
                                  onDoubleClick={(e) =>
                                    viewProspectDetails(row, column.id)
                                  }
                                  gutterBottom
                                  // style={{ cursor: "pointer", color: "black", textDecoration: 'none' }}
                                >
                                  {value}
                                </p>
                              ) : column.type &&
                                column.type === "attach" &&
                                value ? (
                                <Link
                                  // href={staticFiles + value}
                                  target="_blank"
                                  variant="body2"
                                  gutterBottom
                                  style={{ cursor: "pointer" }}
                                >
                                  {value}
                                </Link>
                              ) : // ) : column.type &&
                              //   column.type === "number" &&
                              //   column.name === "Invested returns CAGR %" &&
                              //   value ? (
                              //   <Tooltip title="Add" arrow>
                              //     {value}
                              //   </Tooltip>
                              value === null ? (
                                <div>N/A</div>
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </>
              ) : (
                <TableRow>
                  <TableCell
                    colspan="9"
                    style={{ "text-align": "center", margin: "10px 0px" }}
                  >
                    No Data Available...
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <div>
          {/* <tab />   // Need To Comment This           */}
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 500]}
            component="div"
            // count={totalRowCount}
            count={myparam === 9 ? totalRowCount : orignalRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            // style={{width:'27rem'}}
          />
        </div>
      </Paper>
    </>
  );
}

export default MisSalesReportParent;
